import { render } from "./QuotationModal.vue?vue&type=template&id=c97dd83c&scoped=true"
import script from "./QuotationModal.vue?vue&type=script&lang=js"
export * from "./QuotationModal.vue?vue&type=script&lang=js"

import "./QuotationModal.vue?vue&type=style&index=0&id=c97dd83c&lang=scss"
import "./QuotationModal.vue?vue&type=style&index=1&id=c97dd83c&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c97dd83c"]])

export default __exports__